export default __webpack_public_path__ + "static/media/vehicle_group.c1d539d7.svg";